import React from 'react';

import { Card, CardContent, CardHeader, Grid} from '@mui/material';
import {defineMessages, useIntl} from 'react-intl';

import {Head} from '@wheeebo/polaris-ui';

import VehicleCreateForm from '@components/form/VehicleCreateForm';

const msgs = defineMessages({
  textTitle: {
    id: 'pages.admin.VehicleRegisterPage.text.title',
    defaultMessage: 'Register a vehicle',
  },
  textContent: {
    id: 'pages.admin.VehicleRegisterPage.text.content',
    defaultMessage: 'A mission is a flight project, which can be composed of a single or multiple flight paths.',
  },
});

function VehicleRegisterPage(): JSX.Element {
  const intl = useIntl();
  return (
    <Grid container spacing={1}>
      <Head title="Register a vehicle" />
      <Grid item xs={8}>
        <Card>
          <CardHeader title={intl.formatMessage(msgs.textTitle)} subheader={intl.formatMessage(msgs.textContent)} />
          <CardContent>
            <VehicleCreateForm />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default React.memo(VehicleRegisterPage);
